import { useSelector } from 'react-redux';

export default function useIsAuthorised() {
    return useSelector(state => state.auth.isAuthenticated);
}
